import { render, staticRenderFns } from "./BMW2024ChargingDisclosurei4.vue?vue&type=template&id=552b10dc&"
import script from "./BMW2024ChargingDisclosurei4.vue?vue&type=script&lang=js&"
export * from "./BMW2024ChargingDisclosurei4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports